{
  "COMPOSE_REDIRECT": {
    "OPENING": "Åpner en ny samtale med {email}…",
    "NO_EMAIL": "Ingen e-postadresse oppgitt. Bruk ?email=name@example.com",
    "CONTACT_ERROR": "Kunne ikke finne kontakten for {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Velg en samtale fra venstre panel",
    "CSAT_REPLY_MESSAGE": "Please rate the conversation",
    "404": "Sorry, we cannot find the conversation. Please try again",
    "SWITCH_VIEW_LAYOUT": "Switch the layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "The identity of this user is not verified",
    "NO_MESSAGE_1": "Å nei! Ser ut til at det ikke er noen meldinger fra kunder i innboksen din.",
    "NO_MESSAGE_2": " for å sende en melding til siden din!",
    "NO_INBOX_1": "Tjohei! Det ser ut til at du ikke har lagt til noen innbokser enda.",
    "NO_INBOX_2": " for å komme i gang",
    "NO_INBOX_AGENT": "Uff da! Det ser ut til at du ikke er en del av innboksen. Kontakt systemansvarlig",
    "SEARCH_MESSAGES": "Søk etter meldinger i samtaler",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Oversettelse",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Søk i meldinger",
      "RESULT_TITLE": "Search Results",
      "LOADING_MESSAGE": "Knuser data...",
      "PLACEHOLDER": "Skriv tekst for å søke etter meldinger",
      "NO_MATCHING_RESULTS": "No results found."
    },
    "UNREAD_MESSAGES": "Uleste meldinger",
    "UNREAD_MESSAGE": "Ulest melding",
    "CLICK_HERE": "Klikk her",
    "LOADING_INBOXES": "Laster innbokser",
    "LOADING_CONVERSATIONS": "Laster samtaler",
    "CANNOT_REPLY": "Du kan ikke svare på grunn av",
    "24_HOURS_WINDOW": "24-timers meldingsrestriksjon",
    "NOT_ASSIGNED_TO_YOU": "This conversation is not assigned to you. Would you like to assign this conversation to yourself?",
    "ASSIGN_TO_ME": "Assign to me",
    "TWILIO_WHATSAPP_CAN_REPLY": "You can only reply to this conversation using a template message due to",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-timers meldingsrestriksjon",
    "REPLYING_TO": "Du svarer til:",
    "REMOVE_SELECTION": "Fjern utvalget",
    "DOWNLOAD": "Last ned",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Gjør dette før du sender:",
      "EXECUTE": "Utfør",
      "RETRY": "Prøv igjen",
      "CONFIRM": "Utføre nå?",
      "CONFIRM_YES": "Ja, utfør",
      "CONFIRM_NO": "Avbryt",
      "RUNNING": "Utføres…",
      "DONE": "Utført",
      "CLAIM_DELAYED": "opprettes når bestillingen er levert",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Det ble opprettet en NY reklamasjon {reference}, {planned} er lukket — rediger utkastteksten",
        "NEW_CLAIM": "Det ble opprettet en NY reklamasjon {reference} i stedet for å oppdatere {planned} — rediger utkastteksten",
        "OTHER_CLAIM": "Reklamasjon {reference} ble oppdatert i stedet for {planned} — rediger utkastteksten",
        "EXISTING_CLAIM": "Ingen ny reklamasjon ble opprettet, den eksisterende {reference} ble oppdatert — rediger utkastteksten",
        "OTHER": "Dette gikk annerledes enn utkastet forutsatte — rediger utkastteksten"
      },
      "FAILED": "Mislyktes",
      "UNREACHABLE": "Boten kunne ikke nås",
      "REQUEST_FAILED": "Handlingen kunne ikke startes. Prøv igjen.",
      "ACTIONS": {
        "CANCEL_ORDER": "Avbestill bestillingen",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Endre betalingen til postoppkrav",
        "CREATE_CLAIM": "Send inn en reklamasjon",
        "CREATE_OR_UPDATE_CLAIM": "Send inn eller oppdater en reklamasjon",
        "EXTEND_ORDER_PICKUP_DATE": "Forleng hentefristen"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Laster opp vedlegg...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Message deleted successfully",
    "FAIL_DELETE_MESSSAGE": "Couldn't delete message! Try again",
    "NO_RESPONSE": "No response",
    "RESPONSE": "Response",
    "RATING_TITLE": "Rating",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Løs",
      "REOPEN_ACTION": "Gjenåpne",
      "OPEN_ACTION": "Åpne",
      "OPEN": "Mer",
      "CLOSE": "Lukk",
      "DETAILS": "detaljer",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed until tomorrow",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed until next week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed until next reply",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Mark as pending",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Snooze until",
        "NEXT_REPLY": "Next reply",
        "TOMORROW": "Tomorrow",
        "NEXT_WEEK": "Next week"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze until",
      "APPLY": "Snooze",
      "CANCEL": "Avbryt"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Ingen",
        "URGENT": "Haster",
        "HIGH": "Høy",
        "MEDIUM": "Middels",
        "LOW": "Lav"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "None",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "No results found",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Åpne i ny fane",
      "COPY_LINK": "Kopier lenke til samtalen",
      "COPY_LINK_SUCCESS": "Lenke til samtalen kopiert til utklippstavlen",
      "PENDING": "Mark as pending",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Reopen conversation",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Until next reply",
        "TOMORROW": "Until tomorrow",
        "NEXT_WEEK": "Until next week"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "MSG_INPUT": "Shift + enter for ny linje. Start med '/' for å velge et forhåndslagd svar.",
      "PRIVATE_MSG_INPUT": "Skift + enter for ny linje. Dette vil kun være synlig for agenter",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Message signature is not configured, please configure it in profile settings.",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "WhatsApp-vinduet på 24 timer er utløpt. Svar med en mal.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Svaret ditt ser ut til å være på {draftLanguage}, men denne samtalen er på {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Oversett",
      "REPLY": "Svar",
      "PRIVATE_NOTE": "Privat notat",
      "SEND": "Send",
      "CREATE": "Legg til notat",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Vis rik tekstredigering",
      "HEADING_LEVEL": {
        "LABEL": "Tekststil",
        "NORMAL": "Normal tekst",
        "H1": "Overskrift 1",
        "H2": "Overskrift 2",
        "H3": "Overskrift 3"
      },
      "EDITOR": {
        "BOLD": "Fet",
        "ITALIC": "Kursiv",
        "UNDERLINE": "Understrek",
        "TEXT_COLOR": "Tekstfarge",
        "BG_COLOR_LABEL": "Bakgrunnsfarge",
        "FONT_SIZE_LABEL": "Skriftstørrelse",
        "FONT_SIZE": {
          "XS": "Liten",
          "SM": "Middels liten",
          "MD": "Standard",
          "LG": "Stor",
          "XL": "Ekstra stor",
          "XXL": "Enorm"
        },
        "CODE": "Kode",
        "LINK": "Legg til eller fjern lenke",
        "CREATE_LINK": "Opprett en lenke",
        "SAVE_LINK": "Lagre",
        "CANCEL": "Avbryt",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Angre",
        "REDO": "Gjør om",
        "BULLET_LIST": "Punktliste",
        "ORDERED_LIST": "Nummerert liste",
        "BLOCKQUOTE": "Blokksitat",
        "H1": "Overskrift 1",
        "H2": "Overskrift 2",
        "H3": "Overskrift 3",
        "IMAGE_UPLOAD": "Last opp bilde",
        "CLEAR_FORMATTING": "Fjern formatering",
        "COLOR": {
          "RED": "Rød",
          "YELLOW": "Gul",
          "BLUE": "Blå",
          "ROSE_RED": "Roserød",
          "DEEP_CYAN": "Dyp cyan",
          "ORANGE": "Oransje",
          "PISTACHIO": "Pistasj",
          "PURPLE": "Lilla",
          "FUCHSIA": "Fuksia",
          "SILVER": "Sølv",
          "NAVY": "Marineblå",
          "OLD_PINK": "Gammelrosa",
          "AQUA": "Turkis",
          "BROWN": "Brun",
          "OLIVE": "Oliven",
          "GOLD": "Gull",
          "BEIGE": "Beige",
          "WINE": "Vinrød",
          "FOREST": "Skoggrønn",
          "GREEN": "Grønn",
          "BLUE_GREY": "Blågrå",
          "RUBY_RED": "Rubinrød",
          "CHESTNUT_BROWN": "Kastanjebrun",
          "ASH_GREY": "Askegrå"
        },
        "BG_COLOR": {
          "RED": "Rød",
          "YELLOW": "Gul",
          "BLUE": "Blå",
          "ROSE_RED": "Roserød",
          "DEEP_CYAN": "Dyp cyan",
          "ORANGE": "Oransje",
          "PISTACHIO": "Pistasj",
          "PURPLE": "Lilla",
          "FUCHSIA": "Fuksia",
          "SILVER": "Sølv",
          "NAVY": "Marineblå",
          "OLD_PINK": "Gammelrosa",
          "AQUA": "Turkis",
          "BROWN": "Brun",
          "OLIVE": "Oliven",
          "GOLD": "Gull",
          "BEIGE": "Beige",
          "WINE": "Vinrød",
          "FOREST": "Skoggrønn",
          "GREEN": "Grønn",
          "BLUE_GREY": "Blågrå",
          "RUBY_RED": "Rubinrød",
          "CHESTNUT_BROWN": "Kastanjebrun",
          "ASH_GREY": "Askegrå"
        }
      },
      "TIP_EMOJI_ICON": "Vis emoji-velger",
      "TIP_ATTACH_ICON": "Legg ved filer",
      "TIP_AUDIORECORDER_ICON": "Record audio",
      "TIP_AUDIORECORDER_PERMISSION": "Allow access to audio",
      "TIP_AUDIORECORDER_ERROR": "Could not open the audio",
      "DRAG_DROP": "Drag and drop here to attach",
      "START_AUDIO_RECORDING": "Start audio recording",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Add bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Avbryt"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Legg til en SMS-innboks for å sende SMS-svar.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privat notat: bare synlig for deg og ditt team",
    "CHANGE_STATUS": "Samtalestatus er endret",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Tildelt agent er endret",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Sendt av:",
    "BOT": "Bot",
    "SEND_FAILED": "Couldn't send message! Try again",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Velg agent",
      "REMOVE": "Fjern",
      "ASSIGN": "Tildel"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopier",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Slett",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Slett",
        "CANCEL": "Avbryt"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Samtale ble løst av {userName}",
          "CONTACT_RESOLVED": "Conversation was resolved by {contactName}",
          "OPEN": "Samtalen ble gjenåpnet av {userName}",
          "PENDING": "Conversation was marked as pending by {userName}",
          "SNOOZED": "Conversation was snoozed by {userName}",
          "AUTO_RESOLVED": "Samtale ble automatisk merket løst på grunn av {duration} dager med inaktivitet",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Systemet løste samtalen fordi ticketen ble lukket på Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} tilordnet seg denne samtalen",
          "ASSIGNED": "Tildelt til {assigneeName} av {userName}",
          "REMOVED": "{userName} fjernet tildelingen til samtalen"
        },
        "TEAM": {
          "ASSIGNED": "Tildelt til {teamName} av {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assigned to {assigneeName} via {teamName} by {userName}",
          "REMOVED": "Unassigned from {teamName} by {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} la til {labels}",
          "REMOVED": "{userName} fjernet {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} har dempet samtalen",
        "UNMUTED": "{userName} har opphevet dempingen av samtalen",
        "CONTACT_BLOCKED": "{userName} blokkerte kontakten",
        "CONTACT_UNBLOCKED": "{userName} opphevet blokkeringen av kontakten",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Flyttet fordi kontaktens bestillinger kun kommer fra butikken {storeName} (siste bestilling {orderId}), og butikkens robot svarer i denne innboksen.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatiseringen ble hoppet over fordi kontakten er blokkert",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatiseringen \"{ruleName}\" kunne ikke flytte denne samtalen fra innboksen {sourceInboxName} til innboksen {targetInboxName} fordi innboksene ikke er kompatible.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatiseringen \"{ruleName}\" kunne ikke flytte denne samtalen fra innboksen {sourceInboxName} til innboksen {targetInboxName} fordi kontakten ikke har en e-postadresse.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatisering \"{ruleName}\" kunne ikke sende en melding: denne telefoninnboksen kan ikke sende SMS fordi kontoen ikke har noen SMS-innboks. Regelen ble slått av, og administratorene fikk en e-post.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatisering \"{ruleName}\" kunne ikke sende en melding: vedlegg kan ikke sendes som SMS fra denne innboksen. Regelen ble slått av, og administratorene fikk en e-post.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macro \"{macroName}\" sendte ikke meldingen sin: denne telefoninnboksen kan ikke sende SMS fordi kontoen ikke har noen SMS-innboks.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macro \"{macroName}\" sendte ikke meldingen sin: vedlegg kan ikke sendes som SMS fra denne innboksen.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macro \"{macroName}\" sendte ikke meldingen sin: boten håndterer denne samtalen. Åpne samtalen først.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macro \"{macroName}\" sendte ikke meldingen sin: denne innboksen er markert for sletting. Flytt samtalen til en annen innboks først.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatiseringen \"{ruleName}\" sendte en e-post til {contactEmail} i en ny samtale [#{conversationId}]({conversationPath}) i innboksen {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatiseringen \"{ruleName}\" startet denne samtalen på grunn av samtalen [#{conversationId}]({conversationPath}) i innboksen {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatiseringen \"{ruleName}\" kunne ikke sende meldingen i en ny samtale i innboksen {inboxName} fordi kontakten ikke har en e-postadresse.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatiseringen \"{ruleName}\" sendte en SMS til {contactPhone} i en ny samtale [#{conversationId}]({conversationPath}) i innboksen {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatiseringen \"{ruleName}\" kunne ikke sende SMS i en ny samtale i innboksen {inboxName} fordi kontakten ikke har et telefonnummer.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Kunde"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "besvart andre steder, ringte i {duration}",
            "NO_ANSWER": "ikke besvart, ringte i {duration}",
            "REJECTED": "avvist etter å ha ringt i {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Løst automatisk etter {count} mislykkede tilbakeringinger",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Samtaleopptaket ble slettet av {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Usynlig for kunden",
    "SENT_VIA_EMAIL": "Også sendt til kontakten på e-post ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Denne innboksen er markert for sletting, så kundens svar ville aldri komme frem. Flytt samtalen til en annen innboks for å svare.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Denne kontakten har en annen åpen samtale #{id}",
      "MULTIPLE": "Denne kontakten har andre åpne samtaler ({count})",
      "OPEN": "Åpne",
      "SHOW": "Vis"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Be kunden om å dele WhatsApp-telefonnummeret sitt",
      "PENDING_ACTION": "Forespørsel om kontaktopplysninger venter",
      "STATES": {
        "PENDING": "Venter på kontaktopplysninger",
        "SHARED": "Telefonnummer delt",
        "IDENTITY_CONFLICT": "Telefonnummer må gjennomgås"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Send kopi av samtale",
    "DESC": "Send en kopi av samtalen til den angitte e-postadressen",
    "SUBMIT": "Send",
    "CANCEL": "Avbryt",
    "SEND_EMAIL_SUCCESS": "Kopi av samtalen ble sendt",
    "SEND_EMAIL_ERROR": "Det oppstod en feil. Prøv igjen",
    "FORM": {
      "SEND_TO_CONTACT": "Send kopi av samtalen til kunden",
      "SEND_TO_AGENT": "Send kopi av samtalen til den tildelte agenten",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send kopi av samtalen til en annen e-postadresse",
      "EMAIL": {
        "PLACEHOLDER": "Skriv inn en e-postadresse",
        "ERROR": "Vennligst skriv inn en gyldig e-postadresse"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hey 👋, Welcome to {installationName}!",
    "DESCRIPTION": "Thanks for signing up. We want you to get the most out of {installationName}. Here are a few things you can do in {installationName} to make the experience delightful.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Read our latest updates",
    "ALL_CONVERSATION": {
      "TITLE": "All your conversations in one place",
      "DESCRIPTION": "View all the conversations from your customers in one single dashboard. You can filter the conversations by the incoming channel, label and status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite your team members",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Assigned Agent",
    "SELF_ASSIGN": "Assign to me",
    "TEAM_LABEL": "Assigned Team",
    "SELECT": {
      "PLACEHOLDER": "None"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Contact Details",
      "CONVERSATION_ACTIONS": "Conversation Actions",
      "CONVERSATION_LABELS": "Samtaleetiketter",
      "CONVERSATION_INFO": "Conversation Information",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Tidligere samtaler",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Ventende",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "No attributes found",
    "UPDATE": {
      "SUCCESS": "Attribute updated successfully",
      "ERROR": "Unable to update attribute. Please try again later"
    },
    "ADD": {
      "TITLE": "Add",
      "SUCCESS": "Attribute added successfully",
      "ERROR": "Unable to add attribute. Please try again later"
    },
    "DELETE": {
      "SUCCESS": "Attribute deleted successfully",
      "ERROR": "Unable to delete attribute. Please try again later"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Add attributes",
      "PLACEHOLDER": "Search attributes",
      "NO_RESULT": "No attributes found"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "To",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subject"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "No results found",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Ordrenummer",
    "EXTERNAL_ID": "Ekstern ID",
    "PAYMENT_TYPE": "Betalingsmåte",
    "PAYMENT_DATE": "Betalingsdato",
    "DELIVERY_PROVIDER": "Transportør",
    "EXPECTED_DATE_OF_DELIVERY": "Forventet levering",
    "DATE_OF_DELIVERY": "Levert",
    "EXPEDITION_DATE": "Forsendelsesdato",
    "INTERNAL_NOTE": "Butikknotat",
    "PACKAGE_NUMBER": "Sending"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
